import { __assign } from "tslib";
import React from 'react';
import DeviationGrid3x3 from './layouts/DeviationGrid3X3';
import SingleColumnTextual from './layouts/SingleColumnTextual';
import DeviationMosaic from './layouts/DeviationMosaic';
import TierList from './layouts/TierList';
import DeviationMobileList from './layouts/DeviationMobileList';
import Groups from './layouts/Groups';
import Collections from './layouts/Collections';
import Dealer from './layouts/Dealer';
import MonetizationBlock from './layouts/MonetizationBlock';
import Users from './layouts/Users';
import Ad from './layouts/Ad';
var genericLayouts = {
    1: DeviationGrid3x3,
    2: SingleColumnTextual,
    3: DeviationMosaic,
    4: TierList,
    5: DeviationMobileList,
};
var uniqueLayouts = {
    subscription_promotion: MonetizationBlock,
    monetization_promotion_tier: MonetizationBlock,
    monetization_promotion_commission: MonetizationBlock,
    groups: Groups,
    collections: Collections,
    dealer: Dealer,
    users: Users,
    ad_top: Ad,
    ad_btf: Ad,
};
function getBlockComponent(block) {
    if (block.layout === 0) {
        return uniqueLayouts[block.contentType];
    }
    return genericLayouts[block.layout];
}
var SidebarBlock = function (props) {
    var BlockComponent = getBlockComponent(props.block);
    if (BlockComponent) {
        return React.createElement(BlockComponent, __assign({}, props));
    }
    return null;
};
SidebarBlock.displayName = 'SidebarBlock';
export default SidebarBlock;
//# sourceMappingURL=SidebarBlock.js.map